import { StyledReactSelect } from '@fountain/fountain-ui-components';
import { Stage } from 'api-clients/monolith';
import React, { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';

import { Error } from 'components/Error';
import { useDebounce } from 'hooks/useDebounce';
import { useUnscopedStages } from 'hooks/useUnscopedStages';

import { messages } from './messages';

interface WorkflowStageSelectProps {
  workflowId: string;
  onChange: (stage: Stage) => void;
  value: string;
  error?: boolean;
}
export const WorkflowStageSelect: React.VFC<WorkflowStageSelectProps> = ({
  workflowId,
  onChange,
  value,
  error,
}) => {
  const intl = useIntl();
  const [query, setQuery] = useState('');
  const [inputValue, setInputValue] = useState('');
  const debounceSetQuery = useDebounce(setQuery, 500);
  const PER_PAGE = 100;

  const { result } = useUnscopedStages({
    workflowId,
    query,
    perPage: PER_PAGE,
  });

  const options = result.status === 'ready' ? result.data.stages : [];
  const selected = options.find(opt => opt.id === value) ?? null;

  const handleInputChange = useCallback(
    (text: string, action: { action: string }) => {
      if (action.action === 'input-change') {
        setInputValue(text);
        debounceSetQuery(text);
      }
    },
    [debounceSetQuery],
  );

  const handleChange = useCallback(
    (stage: Stage) => {
      setInputValue('');
      onChange(stage);
    },
    [onChange],
  );

  return (
    <>
      <StyledReactSelect
        aria-label={intl.formatMessage(messages.stage)}
        isLoading={result.isLoading}
        options={options}
        label={intl.formatMessage(messages.stage)}
        placeholder={intl.formatMessage(messages.selectAStage)}
        onChange={handleChange}
        onInputChange={handleInputChange}
        inputValue={inputValue}
        getOptionLabel={(option: Stage) => option.title}
        getOptionValue={(option: Stage) => option.id}
        value={selected}
        error={!value && error}
        required
      />
      <Error align="right" error={!value && error} />
    </>
  );
};
